// Map file extensions to highlight.js language slugs. Shared by the chat
// expanded tool-result view (chat-message.tsx) and the file preview dialog
// (file-preview-dialog.tsx) so both surfaces highlight the same set of files
// the same way.
const EXT_TO_LANG: Record<string, string> = {
  ts: 'typescript',
  tsx: 'typescript',
  js: 'javascript',
  jsx: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
  json: 'json',
  py: 'python',
  rs: 'rust',
  go: 'go',
  rb: 'ruby',
  java: 'java',
  kt: 'kotlin',
  swift: 'swift',
  sh: 'bash',
  zsh: 'bash',
  bash: 'bash',
  md: 'markdown',
  mdx: 'markdown',
  yaml: 'yaml',
  yml: 'yaml',
  css: 'css',
  scss: 'scss',
  html: 'xml',
  xml: 'xml',
  sql: 'sql',
  toml: 'ini',
  diff: 'diff',
  patch: 'diff',
};

/** Returns the highlight.js language slug for a file path's extension, or
 *  `null` when no mapping exists (caller can fall back to plain text). */
export const languageFromPath = (path: string | undefined): string | null => {
  if (!path) return null;
  const ext = path.split('.').pop()?.toLowerCase();
  return (ext && EXT_TO_LANG[ext]) ?? null;
};
